import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import { Lock, User, Sun } from 'lucide-react';
import axios from 'axios';

import { API } from '../lib/api';
import { announceTokenRenewed, getToken, setToken } from '../lib/authClient';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isReauth = new URLSearchParams(location.search).has('reauth');

  useEffect(() => {
    if (isReauth) return;
    if (getToken()) navigate('/admin/dashboard', { replace: true });
  }, [isReauth, navigate]);

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, credentials);
      const { access_token } = response.data;

      setToken(access_token);
      announceTokenRenewed(access_token);

      if (isReauth) {
        toast.success('Sessão renovada! Pode fechar esta aba.');
        setTimeout(() => {
          try { window.close(); } catch (_) {}
        }, 600);
      } else {
        toast.success('Login realizado com sucesso!');
        navigate('/admin/dashboard');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Credenciais inválidas. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl mb-4">
            <Sun className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">
            3M Solar
          </h1>
          <p className="text-gray-400">Área Administrativa</p>
        </div>

        {/* Login Card */}
        <Card className="bg-white/10 backdrop-blur-lg border-gray-700 p-8">
          <h2 className="text-2xl font-bold text-white mb-6 text-center">
            {isReauth ? 'Renovar Sessão' : 'Login Admin'}
          </h2>
          {isReauth && (
            <p className="text-sm text-orange-200 bg-orange-500/10 border border-orange-500/30 rounded-lg p-3 mb-6 text-center">
              Sua sessão expirou. Faça login aqui — sua aba original será atualizada automaticamente.
            </p>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="username" className="block text-sm font-medium text-gray-300 mb-2">
                Usuário
              </label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <Input
                  type="text"
                  id="username"
                  name="username"
                  value={credentials.username}
                  onChange={handleChange}
                  required
                  className="w-full pl-10 pr-4 py-3 bg-gray-800 border-gray-700 text-white rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  placeholder="Digite seu usuário"
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2">
                Senha
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <Input
                  type="password"
                  id="password"
                  name="password"
                  value={credentials.password}
                  onChange={handleChange}
                  required
                  className="w-full pl-10 pr-4 py-3 bg-gray-800 border-gray-700 text-white rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  placeholder="Digite sua senha"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50"
            >
              {isLoading ? 'Entrando...' : 'Entrar'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-gray-400 hover:text-orange-500 transition-colors text-sm"
            >
              ← Voltar ao site
            </button>
          </div>
        </Card>

        {/* Info */}
        <div className="mt-6 text-center text-sm text-gray-400">
          <p>Credenciais padrão: admin / admin123</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
